import Image from "next/image";
import React, { useState } from "react";

const UspAnnualSavingsMobile = () => {
  const [isPopupOpen, setPopupOpen] = useState({ open: false, code: "" });

  const openPopup = (code: string) => {
    setPopupOpen({ open: true, code: code });
  };

  const closePopup = () => {
    setPopupOpen({ open: false, code: "" });
  };

  return (
    <>
      <div className="mx-auto bg-white w-full xl:px-0 md:px-6 lg:!px-6 relative md:bg-bottom bg-center square_grid_bg bg-repeat md:bg-cover bg-c bg-[length:100% 100%] md:pt-[60px] pt-[24px] md:pb-0 pb-[0px]">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-20 relative">
          <h2 className="font-semibold md:text-[36px] text-[24px] text-[#05192E] text-center md:mb-[40px] mb-[30px] leading-normal">
            <span className="md:pb-0 inline-block border-[#ca7216] border-b-2">
              Estimated annual savings
            </span>

            <div className="border-[#3174d6] mx-auto border-[1px] rounded-[8px] mt-[20px] w-[331px]">
              <div className="overflow-x-auto rounded-[8px]">
                <table className="w-full">
                  <thead></thead>
                  <tbody className="bg-white">
                    <tr className="">
                      <td className="border-[1px] text-[#0C2036] border-[#C0DDFD] text-left">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] leading-[135%] block font-normal ">
                          Annual Salary
                        </span>
                      </td>
                      <td className="border-[1px] text-[#0C2036] border-[#C0DDFD] text-center">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] leading-[135%] text-[12px] block font-semibold">
                          $60,000+
                        </span>
                      </td>
                      {/* <td className="border-[1px] text-[#0C2036] border-[#C0DDFD] text-center">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] leading-[135%] text-[12px] block font-semibold">
                          ~₹50 lakhs+
                        </span>
                      </td> */}
                    </tr>

                    <tr className="">
                      <td className="border-[1px] text-[#0C2036] border-[#C0DDFD] text-left">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] leading-[135%] block font-normal">
                          Student Loan
                          <br /> EMI (Principle + Int.)
                        </span>
                      </td>
                      <td className="border-[1px] text-[#D05757] border-[#C0DDFD] text-center">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] leading-[135%] text-[12px] block font-semibold">
                          - $20,000
                        </span>
                      </td>
                      {/* <td className="border-[1px] text-[#D05757] border-[#C0DDFD] text-center">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] leading-[135%] text-[12px] block font-semibold">
                          ~₹17 lakhs
                        </span>
                      </td> */}
                    </tr>

                    <tr className="">
                      <td className="border-[1px] text-[#0C2036] border-[#C0DDFD] text-left">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] leading-[135%] block font-normal">
                          Taxes
                        </span>
                      </td>
                      <td className="border-[1px] text-[#D05757] border-[#C0DDFD] text-center">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] leading-[135%] text-[12px] block font-semibold">
                          - $5,000
                        </span>
                      </td>
                      {/* <td className="border-[1px] text-[#D05757] border-[#C0DDFD] text-center">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] leading-[135%] text-[12px] block font-semibold">
                          ~₹4 lakhs
                        </span>
                      </td> */}
                    </tr>

                    <tr className="">
                      <td className="border-[1px] text-[#0C2036] border-[#C0DDFD] text-left">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] leading-[135%] block font-normal">
                          Living Expenses
                        </span>
                      </td>
                      <td className="border-[1px] text-[#D05757] border-[#C0DDFD] text-center">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] leading-[135%] text-[12px] block font-semibold">
                          - $15,000
                        </span>
                      </td>
                      {/* <td className="border-[1px] text-[#D05757] border-[#C0DDFD] text-center">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] leading-[135%] text-[12px] block font-semibold">
                          ~₹12 lakhs
                        </span>
                      </td> */}
                    </tr>

                    <tr className="bg-[#C0DDFD]">
                      <td className="border-[1px] text-[#0C2036] border-[#C0DDFD] text-left">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] leading-[135%] block font-normal">
                          Savings per Year
                        </span>
                      </td>
                      <td className="border-[1px] text-[#0C2036] border-[#C0DDFD] text-center">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] text-[15px] leading-[135%] block font-semibold">
                          $20,000+
                        </span>
                      </td>
                      {/* <td className="border-[1px] text-[#0C2036] border-[#C0DDFD] text-left">
                        <span className="py-3 md:px-8 px-2 md:text-[20px] text-[15px] leading-[135%] block font-semibold">
                          ~₹17 lakhs+
                        </span>
                      </td> */}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="pt-[25px] pb-[10px] text-center">
              <p className="text-[#000000] text-[14px] leading-[16px] font-normal md:block hidden">
                Save upto
              </p>

              <div className="bg-[#FFBA08] w-[60%] mx-auto">
                <p className="text-[18px] leading-[normal] font-bold text-[#000000] tracking-[0.72px] px-1 py-1">
                  Save $60,000 in 3 years
                </p>
              </div>
            </div>
          </h2>
        </div>

        <div
          className="bg-[#061A2F] p-[15px] relative"
          onClick={() => {
            openPopup("QqFAuZzvnDs");
          }}
        >
          <Image
            src="/images/accounting/usp/global.png"
            alt="Miles US Pathway Roadmap"
            className="mx-auto w-full cursor-pointer"
            width={480}
            height={252}
            priority
          />

          <div className="flex items-center justify-center md:rounded-[15px] rounded-[15px] absolute left-0 right-0 bottom-[32%]">
            <Image
              src="/images/accounting/usp/video-icon.png"
              alt="Accountants "
              className="cursor-pointer w-[50px]"
              width={110}
              height={110}
            />
          </div>
        </div>

        {isPopupOpen.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999]">
            <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
              <button
                onClick={closePopup}
                className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
              >
                ✕
              </button>
              <iframe
                className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
                width="100%"
                height="320"
                src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UspAnnualSavingsMobile;
